/** The five operational codes a production-miss day names (gap A8, migration 0023) —
 * deliberately NOT the FA seven: a miss reason says what HAPPENED, the FA codes say who PAYS.
 * `other` is the free-text escape and requires the note; the server refuses it bare.
 *
 * This is the single frontend copy (the FA_REASONS dedup lesson — there were three):
 * FieldTimesheetTab renders its gate from it, and the queued validation plan (status bars,
 * overload flags) must consume it too, never mint a parallel list. The codes are pinned
 * against the backend tuple by test — same literals both sides. */
export const MISS_REASONS: { code: string; label: string }[] = [
  { code: 'weather', label: 'Weather' },
  { code: 'ground', label: 'Ground conditions' },
  { code: 'breakdown', label: 'Equipment breakdown' },
  { code: 'crew', label: 'Crew shortfall' },
  { code: 'other', label: 'Other (add note)' },
];
